var capitalize = function capitalize(str) {
  return "".concat(str[0].toUpperCase()).concat(str.slice(1));
};

export { capitalize };
